<template>
  <el-card>
    <h1>{{ langData.hostess }}</h1>
    <!-- 搜索 -->
    <el-row class="search" :class="{ ar: isAr == 2 }">
      <el-col :xs="24" :lg="1">
        <span>{{ langData.hostessID2 }}:</span>
      </el-col>
      <el-col :xs="24" :lg="3">
        <el-input style="width: 100%" v-model="search.rid"></el-input>
      </el-col>
      <el-col :xs="24" :lg="2">
        <span>{{ langData.country }}:</span>
      </el-col>
      <el-col :xs="24" :lg="3">
        <el-select v-model="search.countryCode" style="width: 100%" clearable filterable>
          <el-option v-for="item in countryList" :key="item.countryCode" :label="item.country" :value="item.code">
          </el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :lg="2">
        <span>{{ langData.hostAccountStatus }}:</span>
      </el-col>
      <el-col :xs="24" :lg="3">
        <el-select v-model="search.accountStatus" clearable style="width: 100%">
          <el-option v-for="item in hostAccountStatusOptions" :key="item.value" :label="langData[item.label]"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :lg="2">
        <span>{{ langData.status }}:</span>
      </el-col>
      <el-col :xs="24" :lg="3">
        <el-select v-model="search.verificationStatus" clearable style="width: 100%">
          <el-option v-for="item in verificationStatusOptions" :key="item.value" :label="langData[item.label]"
            :value="item.value" v-if="item.value != 3">
          </el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :lg="2">
        <span>{{ langData.inviteDate }}:</span>
      </el-col>

      <el-col :xs="24" :lg="4">
        <el-date-picker v-model="search.startDate" value-format="yyyy-MM-dd" type="date" style="width: 100%"
          :placeholder="langData.selectstartDate">
        </el-date-picker>
      </el-col>
      <el-col :xs="24" :lg="4">
        <el-date-picker v-model="search.endDate" value-format="yyyy-MM-dd" type="date" style="width: 100%"
          :placeholder="langData.selectendDate">
        </el-date-picker>
      </el-col>
      <el-col :xs="24" :lg="5">
        <el-button type="primary" @click="query(1)">{{
          langData.search
        }}</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="list" style="width: 100%; margin-bottom: 20px" v-loading="loading" max-height="500" border
        :class="{ ar: isAr == 2 }">
        <el-table-column min-width="110" prop="country" :label="langData.country"></el-table-column>
        <el-table-column min-width="110" prop="name" :label="langData.name">
          <template slot-scope="scope">
            <span class="notranslate">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="110" prop="id" :label="langData.hostessID2"></el-table-column>
        <el-table-column min-width="130" prop="hostAccountStatusOptions" :label="langData.hostAccountStatus">
          <template slot-scope="scope">
            <!-- {{scope.row.hostAccountStatusOptions == 0 || scope.row.hostAccountStatusOptions ?
              langData[hostAccountStatusOptions.find(item => item.value == scope.row.hostAccountStatus).label] : ''
            }} -->
            {{scope.row.hostAccountStatus == 0 || scope.row.hostAccountStatus
              ? langData[hostAccountStatusOptions.find(item => item.value == scope.row.hostAccountStatus).label] : ''}}
          </template>
        </el-table-column>
        <el-table-column min-width="110" prop="hostVerificationStatus" :label="langData.status">
          <template slot-scope="scope">
            {{scope.row.hostVerificationStatus == 0 || scope.row.hostVerificationStatus
              ? langData[verificationStatusOptions.find(item => item.value == scope.row.hostVerificationStatus).label] :
            '' }}
          </template>
        </el-table-column>
        <el-table-column min-width="110" prop="headIcon" :label="langData.headIcon">
          <template slot-scope="scope">
            <el-image :src="scope.row.headIcon" :preview-src-list="[scope.row.headIcon]"></el-image>
          </template>
        </el-table-column>
        <el-table-column min-width="110" prop="photo" :label="langData.photo">
          <template slot-scope="scope">
            <el-image :src="scope.row.photo" :preview-src-list="[scope.row.photo]"></el-image>
          </template>
        </el-table-column>
        <el-table-column min-width="110" prop="registerDate" :label="langData.registerDate"></el-table-column>
        <el-table-column min-width="110" prop="authPassTime" :label="langData.authPassTime"
          :formatter="formatDate"></el-table-column>
        <el-table-column min-width="110" prop="lastLoginTime" :label="langData.lastLoginTime"></el-table-column>
        <el-table-column min-width="110" prop="incomeBalance" :label="langData.incomeBalance">
          <template slot-scope="scope">
            {{ scope.row.incomeBalance ? scope.row.incomeBalance * cr : '' }}
          </template>
        </el-table-column>
        <el-table-column min-width="110" prop="totalUSDIncome" :label="langData.totalUSDIncome">
          <template slot-scope="scope">
            {{ `$${Math.round(scope.row.totalUSDIncome)}` }}
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-pagination layout="prev, pager, next" :total="total" :page-size="pageSize"
    :hide-on-single-page="true"
      :pager-count="isMobile ? 5 : 7" @current-change="handleCurrentChange">
    </el-pagination>
  </el-card>
</template>

<script>
import { getHostInformation } from '@/api/host.js'
import { databaseHost } from '@/utils/lang.js'
import { getCountryList } from '@/api/operate.js'
import { cr } from '@/config'

export default {
  data() {
    return {
      cr: cr,
      loading: false,
      list: [],
      isMobile: window.innerWidth <= 768,
      countryList: [],
      isAr: parseInt(sessionStorage.getItem('lang')),
      langData: {},
      dialogVisible: false,
      verificationStatusOptions: [
        { label: 'all', value: null },
        { label: 'unVerification', value: 0 },
        { label: 'verification', value: 1 },
        { label: 'verComplete', value: 2 },
        { label: 'verFail', value: 3 }
      ],
      hostAccountStatusOptions: [
        { label: 'all', value: null },
        { label: 'available', value: 0 },
        { label: 'banned', value: 1 },
        { label: 'deleted', value: 2 },
        { label: 'eliminated', value: 3 }
      ],
      search: {
        startDate: null,
        endDate: null,
        countryCode: null,
        rid: null,
        verificationStatus: null,
        accountStatus: null
      },
      currentPage: 1,
      total: 0,
      pageSize: 30,
      agentType: [
        JSON.parse(sessionStorage.getItem('loginData')).agentType[0].value,
      ],
      agentName: '',
      agentTypes: JSON.parse(sessionStorage.getItem('loginData')).agentType,
    }
  },
  created() {
    this.query(1)
    this.getCountryCode()
    if (sessionStorage.getItem('lang')) {
      this.langData = databaseHost[parseInt(sessionStorage.getItem('lang'))]
    } else {
      window.sessionStorage.setItem('lang', '1')
      this.langData = databaseHost[1]
    }
     // 添加窗口大小变化监听
     window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    '$store.state.lang': function (val) {
      this.langData = databaseHost[val]
      this.isAr = val
    },
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768
    },
    // 获取国家选项
    async getCountryCode() {
      const { data: res } = await getCountryList()
      this.countryList = res.data.countryList
    },
    formatDate(row, column) {
      if (!row[column.property]) return ''
      // 获取单元格数据
      let data = row[column.property] * 1000
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      )
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.query()
    },
    handleClose() {
      this.dialogVisible = false
      this.agentName = ''
      this.agentType = [this.agentTypes[0].value]
      this.agentTypes = JSON.parse(
        sessionStorage.getItem('loginData')
      ).agentType
    },
    Creates() {
      if (JSON.parse(sessionStorage.getItem('loginData')).canCreateSon == 1) {
        return true
      }
      return false
    },
    // 获取列表
    async query(page) {
      if (page) {
        this.currentPage = page
      }
      // let status
      // if (this.search.hostStatus == 1) {
      //   status = [1, 2, 6]
      // } else {
      //   if (this.search.hostStatus) {
      //     status = [this.search.hostStatus]
      //   } else {
      //     status = []
      //   }
      // }
      this.loading = true
      const { data: res } = await getHostInformation({
        page: this.currentPage,
        ...this.search,
        countryCode: this.search.countryCode || null,
        hostStatus: status,
      })
      this.loading = false
      if (res.code !== 0)
        return this.$message({
          message: res.msg,
          center: true,
          type: 'error',
        })
      this.$message({
        message: res.msg,
        center: true,
        type: 'success',
      })
      this.list = res.data.data
      this.total = res.data.total
    },

    // 获取创建
    async create() {
      let agentType = this.agentType.join()
      const { data: res } = await getAgencyregister({
        agentId: JSON.parse(sessionStorage.getItem('loginData')).agentId,
        agentType: agentType,
        agentName: this.agentName,
      })
      if (res.code !== 0)
        return this.$message({
          message: res.msg,
          center: true,
          type: 'error',
        })
      this.$message({
        message: res.msg,
        center: true,
        type: 'success',
      })

      this.handleClose()
      this.query()
    },
  },
}
</script>


<style lang="scss" scoped></style>